export const MAIN_THEME_COLOR = {
  nmh: '#f6ba20',
  agentik: '#1e78c3'
}
